export default {
  add: 'Añadir',
  edit: 'Editar',
  category: 'Categoría',
  categories: 'Categorías',
  description: 'Descripción',
  amount: 'Monto',
  number: 'Number',
  spentIn: 'Gastos de {month}',
  noCategory: 'Sin Categoría',
  update: 'Actualizar',
  googleLogin: 'Ingresar con Google',
  facebookLogin: 'Ingresar con Facebook',
  password: 'Contraseña',
  signUp: 'Regístrate',
  logIn: 'Accede',
  addNewCategory: 'Añadir Nueva Categoría',
  editCategory: 'Editar Categoría',
  expenses: 'Gastos',
  incomes: 'Ingresos',
  investments: 'Inversiones',
  about: 'Esta es la página Acerca de',
  notFound: 'Esta pagina no existe',
  validations: {
    required: 'El campo {field} no debe estar vacío',
    range: '{field} tiene que estar entre {min} y {max}'
  }
}
